import React from "react";

const CustomListComponent = ({ children, ...props }) => {
  return <div>{children}</div>;
};

export default CustomListComponent;
